import { IsNotEmpty, IsString, IsUUID, IsOptional, MaxLength, IsBoolean, IsEmail, IsInt, IsArray, MinLength } from 'class-validator';

export class TenantEditDTO {

   @IsNotEmpty()
   @IsString()
   @MaxLength(255)
   name: string;

   @IsNotEmpty()
   @IsBoolean()
   active: boolean;

   @IsNotEmpty()
   @IsBoolean()
   sponsored: boolean;

   @IsNotEmpty()
   @IsBoolean()
   trial: boolean;

   @IsOptional()
   @IsString()
   @MaxLength(20)
   vatNo: string;

   @IsNotEmpty()
   @IsString()
   @MaxLength(50)
   contactFirstName: string;

   @IsNotEmpty()
   @IsString()
   @MaxLength(50)
   contactLastName: string;

   @IsNotEmpty()
   @IsEmail()
   @MaxLength(255)
   contactEmail: string;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   contactPhone: string;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   billingFirstName: string;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   billingLastName: string;

   @IsOptional()
   @IsEmail()
   @MaxLength(255)
   billingEmail: string;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   billingPhone: string;

   @IsOptional()
   @IsString()
   @MaxLength(100)
   billingAddress: string;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   billingCity: string;

   @IsOptional()
   @IsString()
   @MaxLength(25)
   billingZip: string;

   @IsOptional()
   @IsInt()
   billingCountry: number;

   @IsOptional()
   @IsString()
   @MaxLength(50)
   costCenter: string;

   @IsNotEmpty()
   @IsBoolean()
   newsletter: boolean;

   @IsNotEmpty()
   @IsInt()
   invoiceBy: number;

   @IsOptional()
   @IsArray()
   @IsString({
      each: true
   })
   @MinLength(36, {
      each: true
   })
   @MaxLength(36, {
      each: true
   })
   users: Array<string>;

   @IsNotEmpty()
   @IsUUID()
   pricelist: string;

   @IsNotEmpty()
   @IsBoolean()
   phoneSupport: boolean;

}
